import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class ScrollThreshold {

    constructor () {
        this.init();
    }

    init() {

        ScrollTrigger.create({
            start: 0,
            end: "max",
            onUpdate: (self) => {

                const currentScrollY = self.scroll();
                const body = document.body;

                // Ab 100px Scroll-Klasse setzen
                if (currentScrollY > 100) {
                    body.classList.add("is-scrolled");
                } else {
                    body.classList.remove("is-scrolled");
                }
            }
        });

    }
}

export default ScrollThreshold;
